import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    // payment_type radio buttons
    "expanseButton",
    "incomeButton",
    "expanseRadio",
    "incomeRadio",
  ];

  connect() {
    this.updateButtonStyles();
  }

  selectExpanse() {
    this.expanseRadioTarget.click();
    this.updateButtonStyles();
  }

  selectIncome() {
    this.incomeRadioTarget.click();
    this.updateButtonStyles();
  }

  updateButtonStyles() {
    if (this.expanseRadioTarget.checked) {
      this.expanseButtonTarget.classList.add("bg-red-700");
      this.expanseButtonTarget.classList.remove("bg-red-500");
    } else {
      this.expanseButtonTarget.classList.add("bg-red-500");
      this.expanseButtonTarget.classList.remove("bg-red-700");
    }

    if (this.incomeRadioTarget.checked) {
      this.incomeButtonTarget.classList.add("bg-green-700");
      this.incomeButtonTarget.classList.remove("bg-green-500");
    } else {
      this.incomeButtonTarget.classList.add("bg-green-500");
      this.incomeButtonTarget.classList.remove("bg-green-700");
    }
  }
}
